import { AlignmentConnectionCreationSystem } from "@inter-ikea-core/core";
import { StabilitySystem } from "@inter-ikea-storagetwo/range/dist/systems/StabilitySystem";
import { InteractableSectionSystem } from "@inter-ikea-storagetwo/range/dist/systems/InteractiveSectionSystem";
import { BROR as appId } from "../constants";
export const systemsDefinitionList = {
    alignmentConnectionCreationSystem: ({ core }) => new AlignmentConnectionCreationSystem(core.services),
    stabilitySystem: ({ core }) => new StabilitySystem(core.services.entityManager),
    interactableSectionSystem: ({ core }) => new InteractableSectionSystem(core, appId),
};
